<template>
  <b-container>
    <h1 class="mb-4">Task Distribution</h1>

    <b-alert v-if="error" variant="danger" show>
      {{ error }}
    </b-alert>

    <b-spinner v-if="loading" label="Loading..." class="my-4" />

    <b-table
      v-else
      :items="distribution"
      :fields="fields"
      bordered
      striped
      hover
      responsive
      small
    >
      <template #cell(name)="data">
        <strong>{{ data.item.name }}</strong>
      </template>

      <template #cell(view)="data">
        <b-button
          size="sm"
          variant="primary"
          :href="`/tasks?user_id=${data.item.user_id}`"
        >
          View
        </b-button>
      </template>
    </b-table>
  </b-container>
</template>

<script>
import TaskDataService from '@/services/TaskDataService';

export default {
  data() {
    return {
      distribution: [],
      loading: true,
      error: null,
      fields: [
        { key: 'name', label: 'User', sortable: true },
        { key: 'open', label: 'Open Tasks', sortable: true },
        { key: 'new', label: 'New Tasks', sortable: true },
        { key: 'overdue', label: 'Overdue Tasks', sortable: true },
        { key: 'view', label: '', sortable: false }
      ]
    };
  },
  created() {
    TaskDataService.getDistribution()
      .then((res) => {
        this.distribution = res.data.map((item) => ({
          user_id: item.user_id, // Make sure this is included in the API response
          ...item
        }));
      })
      .catch((err) => {
        this.error = 'Failed to load task distribution.';
        console.error(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
